import { StatusBadge } from '../../../common/StatusBadge/StatusBadge';
import { RuleResultView } from '../RuleResultView/RuleResultView';
import './JobResultsList.css';

const RESULT_STATUS_PRESENTATION = {
    succeeded: { label: 'Succeeded', variant: 'success' },
    failed: { label: 'Failed', variant: 'danger' },
};

function groupByModelGroup(results) {
    const groups = [];
    const byKey = new Map();
    for (const result of results) {
        const key = result.model_group.object_id ?? '__deleted__';
        let group = byKey.get(key);
        if (!group) {
            group = { key, name: result.model_group.name, results: [] };
            byKey.set(key, group);
            groups.push(group);
        }
        group.results.push(result);
    }
    return groups;
}

export const JobResultsList = ({ results }) => {
    if (results.length === 0) {
        return <div className="rules-empty"><p>No results for this check yet.</p></div>;
    }

    const groups = groupByModelGroup(results);

    return (
        <div className="jrl">
            {groups.map((group) => (
                <div key={group.key} className="jrl-group">
                    <h3 className="jrl-group-title">{group.name ?? 'Deleted model group'}</h3>
                    <div className="rules-table-wrapper">
                        <table className="rules-table">
                            <thead>
                                <tr>
                                    <th className="rules-th">Rule</th>
                                    <th className="rules-th">Kind</th>
                                    <th className="rules-th">Status</th>
                                    <th className="rules-th">Error</th>
                                    <th className="rules-th">Result</th>
                                </tr>
                            </thead>
                            <tbody>
                                {group.results.map((result, index) => {
                                    const presentation = RESULT_STATUS_PRESENTATION[result.status];
                                    return (
                                        <tr key={`${result.rule.object_id ?? 'deleted-rule'}-${index}`} className="rules-tr">
                                            <td className="rules-td rules-td-name">{result.rule.name ?? 'Deleted rule'}</td>
                                            <td className="rules-td">{result.rule_kind}</td>
                                            <td className="rules-td">
                                                <StatusBadge label={presentation.label} variant={presentation.variant} />
                                            </td>
                                            <td className="rules-td">{result.error_code ?? '-'}</td>
                                            <td className="rules-td">
                                                <RuleResultView ruleKind={result.rule_kind} result={result.result} />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default JobResultsList;
